import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { LoadingSpinner } from '../../../shared-components/LoadingSpinner/LoadingSpinner';

const BlogCategoryIndex = () => {
  const router = useRouter();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Handle the redirection and hash removal
    const handleRedirectAndRemoveHash = async () => {
      await router.push('/blog#blogs-categories');

      // Use setTimeout to ensure the scroll happens
      setTimeout(() => {
        if (window.location.hash === '#blogs-categories') {
          window.history.replaceState(null, '', '/blog');
        }
        setLoading(false);
      }, 50);
    };

    handleRedirectAndRemoveHash();
  }, [router]);

  return (
    <div className="flex items-center justify-center h-screen">
      {loading && (
        <div className="flex items-center">
          <LoadingSpinner className="w-8 h-8 mr-2 inline-block border-primary" />
        </div>
      )}
    </div>
  );
};

export default BlogCategoryIndex;
